import React, { useEffect, useRef, useState } from "react"
import { Input, Progress, Button, FormFeedback } from "reactstrap"
import "flatpickr/dist/themes/material_blue.css"
import toast from "react-hot-toast"
import { APICore } from "helpers/api/apiCore"
import { useLogout } from "hooks/useLogout"
import UploadFile from "../../assets/images/icons/upload-file.svg"
import UploadedFileBox from "./uploadedFileBox"
import { urlToFile } from "helpers/common"

const api = new APICore()

const KycDocumentUpload = ({
  fieldKey,
  kycData = null,
  value = null,
  validateMaxSize = true,
  validation,
  extensionAllowedInput = ".jpg,.jpeg,.png",
  extensionAllowed = ["image/jpeg", "image/png", "application/pdf"],
  placeholder = "Upload Document",
  typeError = "Please upload files in JPG, PNG, or PDF format only.",
  preview = false,
}) => {
  const [file, setFile] = useState(value)
  const [progress, setProgress] = useState(0)
  const fileRef = useRef(null)
  const logout = useLogout()

  const tuncateString = (str, maxLength = 35) => {
    if (str.length <= maxLength) return str
    return str.slice(0, maxLength) + "..."
  }

  useEffect(() => {
    if (kycData) {
      convertUrlToFile(
        kycData?.businessAdditionalDetails?.[fieldKey],
        kycData?.businessAdditionalDetails?.[`${fieldKey}_url`]
      )
    }
  }, [fieldKey, kycData])

  const convertUrlToFile = async (name, file) => {
    try {
      const fileObject = await urlToFile(file, name)
      setFile(fileObject)
    } catch (error) {}
  }

  const onUploadFile = async (file) => {
    try {
      if (!file) {
        toast.error("Please select file.", {
          id: "toasterMessage",
        })
        return
      }
      if (!extensionAllowed.includes(file.type)) {
        toast.error(typeError, {
          id: "toasterMessage",
        })
        return
      }

      const maxSize = 10 * 1024 * 1024
      if (validateMaxSize && file.size > maxSize) {
        toast.error("You can upload a maximum 10MB image or Pdf", {
          id: "toasterMessage",
        })
        return
      }
      const { data } = await api.uploadFile(
        "/common/file",
        {
          file,
        },
        (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
          setProgress(progress)
        }
      )

      validation.setFieldValue(fieldKey, data.data.filename)
    } catch (error) {
      if (error.status === 401) {
        logout()
      }
      toast.error(error?.response?.data?.message, { id: "toasterMessage" })
    }
  }

  //   const clearFile = () => {
  //     setFile(null)
  //     validation.setFieldValue(fieldKey, "")
  //   }

  return (
    <React.Fragment>
      <div
        className={`upload-file-input input-wrapper ${
          validation.errors[fieldKey] && "is-invalid"
        }`}
        onClick={() => fileRef?.current?.click()}
      >
        <Input
          name={fieldKey}
          type="file"
          innerRef={fileRef}
          className="form-control d-none"
          placeholder={placeholder}
          accept={extensionAllowedInput}
          onChange={(e) => {
            const file = e.target.files[0]
            if (file) {
              onUploadFile(file)
              setFile(file)
            }
          }}
        />

        <Input
          type="text"
          className="form-control"
          id="horizontal-firstname-Input"
          value={file ? tuncateString(file?.name || file) : placeholder}
          readOnly
        />
        <img src={UploadFile} alt="" />

        {/* 
        <Input
          type="text"
          className="form-control"
          value={file ? file.name : "No file chosen"}
          readOnly
        /> */}
        {/* {!validation.values[fieldKey] ? (
          <Button
            disabled={progress > 0 && progress < 100}
            // onClick={() => onUploadFile()}
            type="button"
          >
            Upload
          </Button>
        ) : (
          <Button
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              clearFile()
            }}
            type="button"
          >
            Delete
          </Button>
        )} */}
      </div>

      {extensionAllowedInput === ".pdf" && (
        <span className="floating-labels">
          File format: pdf | File size: Upto 10mb
        </span>
      )}

      {preview && file && (
        <UploadedFileBox
          label={"Document Preview"}
          href={URL.createObjectURL(file)}
        />
      )}

      {validation.errors[fieldKey] ? (
        <FormFeedback type="invalid">
          {validation.errors[fieldKey]}
        </FormFeedback>
      ) : null}

      {progress > 0 && progress < 100 && (
        <Progress
          className="w-100"
          value={progress}
          style={{
            height: "3px",
          }}
        />
      )}
    </React.Fragment>
  )
}

export default KycDocumentUpload
